/**
 * Organization users management page.
 */

import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useMe } from '@/hooks/useAuth';
import { LoadingSpinner } from '@/components/ui/loading';
import { Plus } from 'lucide-react';
import './users.scss';

export function OrgUsers() {
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="org-users">
      <div className="org-users__header">
        <div>
          <h1 className="h1">Organization</h1>
          <p className="subtitle">Manage team members and permissions</p>
        </div>
        <Button>
          <Plus style={{ marginRight: 'var(--of-space-2)', width: '1rem', height: '1rem' }} />
          Invite User
        </Button>
      </div>

      <Card>
        <h2 className="h3" style={{ marginBottom: 'var(--of-space-4)' }}>Team Members</h2>
        {me && (
          <div className="space-y-2">
            <div className="org-users__member">
              <div className="org-users__member-info">
                <p>{me.user.email}</p>
                <p>{me.user.role || 'Member'}</p>
              </div>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}

